import { ActionContext } from 'vuex';

import { IState } from '@app/store';
import BetSlipOdd from '@core/models/base/BetSlipOdd';
import ISelection from '@core/models/betSlip/ISelection';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { ModalDequeEntryParams } from '@store/modules/ui/shared/modal/modalIndex';
import { featureFlagService } from '@superbet-group/web.lib.flags';

export const ReplacementType = {
    NewBoosted: 'NewBoosted',
    OldBoosted: 'OldBoosted',
} as const;
export type ReplacementType = typeof ReplacementType[keyof typeof ReplacementType];

export function showBoostedOddConflictModal(
    { dispatch }: ActionContext<unknown, IState>,
    { isNewOddBoosted, selections, newSelection }: ConflictPayload,
): Promise<{ isAccepted: boolean }> {
    return new Promise((resolve) => {
        const modalDecisionCallback = ({ isAccepted }: { isAccepted: boolean }) => {
            resolve({ isAccepted });
        };

        const payload: ModalDequeEntryParams = {
            code: modalCodes.boostedOddConflict,
            isClosable: true,
            afterClose: () => resolve({ isAccepted: false }),
            data: {
                removedSelections: selections,
                newSelection,
                isNewOddBoosted,
                modalDecisionCallback,
            },
        };
        dispatch(
            'ui/modal/pushModal',
            payload,
            { root: true },
        );
    });
}

export async function checkIfBoostedOddConflictOccurs(selection: ISelection, currentSelections: ISelection[]): Promise<ReplacementType | undefined> {
    const isEnabled = await featureFlagService.getFeatureValueWithTimeout('show-bet-boost-conflict-modal', false, 500);

    if (!isEnabled) {
        return;
    }

    if (isBoostedOdd(selection.odd) && !isOddInBetslip(selection.odd, currentSelections) && currentSelections.length > 0) {
        return ReplacementType.NewBoosted;
    } else if (currentSelections.some((s) => isBoostedOdd(s.odd)) && !isOddInBetslip(selection.odd, currentSelections)) {
        return ReplacementType.OldBoosted;
    }
}

export function isBoostedOdd(odd: BetSlipOdd | null): boolean {
    return odd?.tags?.includes('singles_only') ?? false;
}

function isOddInBetslip(odd: BetSlipOdd | null, selections: ISelection[]): boolean {
    if (odd == null) {
        return false;
    }

    return selections.some((s) => s.odd?.uuid === odd.uuid);
}

type ConflictPayload = {
    isNewOddBoosted: boolean;
    selections: ISelection[];
    newSelection: ISelection;
};
